// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"352":"8279cc7a","405":"239f0cbe","453":"617c11a4"}[chunkId] + ".chunk.js";
};